import type { LoginRequest, LoginResponseType, ResetPasswordRequest } from '@/types/business/auth';
import type { BaseResponse } from '@/types/common/http';
import { request } from '@/utils/request';
// 后续可以迁移到 @/types/business/auth 模块

/**
 * 用户登录
 * @param req 登录请求体
 */
export function login(req: LoginRequest) {
  return request.post<LoginResponseType>('/auth/login', req);
}

/**
 * 未认证响应接口
 * @param req
 */
export function unauthenticated() {
  return request.get<BaseResponse<void>>('/auth/unAuth');
}

/**
 * 登出
 */
export function logout() {
  return request.get<BaseResponse<void>>('/auth/logout');
}

/**
 * 重置密码
 * @param req
 */
export function resetPassword(req: ResetPasswordRequest) {
  return request.put<BaseResponse<void>>('/profile/password', req);
}
